import { useState, useEffect } from 'react';
import { jobDetailParser } from '../../helpers/parsers/jobDetailParser';

const useFetchJobOffer = (id) => {
  const [jobOffer, setJobOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobOffer = async () => {
      try {
        const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/jobs/${id}`;
        const response = await fetch(url);
        
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Failed to fetch job offer: ${response.status} - ${errorText}`);
        }
        
        const data = await response.json();
        
        // Extract the job offer from the data property
        const jobOfferData = data.data || data;
        
        const parsedData = jobDetailParser(jobOfferData, id);

      
        setJobOffer(parsedData);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchJobOffer();
  }, [id]);

  return { jobOffer, loading, error };
};

export default useFetchJobOffer;
